<template>
  <structure>
    <b-row class="mb-2 mt-2">
      <b-col class="font-weight-bold">Subject optimization</b-col>
      <b-col class="align-self-center col-auto">
        <slider-switch
          class="mr-1"
          v-bind:selected="this.$store.getters.subjectOptimize"
          @click="toggleSubjectOptimize()"
        ></slider-switch>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <span>Put (brackets) around the project specific stuff in your subject line.</span>
        <br />
        <span
          class="font-weight-light"
        >Clockk will use this to determine which project to assign this email to.</span>
      </b-col>
    </b-row>
    <b-row>
      <img id="subject-image" src="../assets/subject-image.png" />
    </b-row>
  </structure>
</template>

<script>
import Structure from "./Structure";

export default {
  name: "Settings",
  components: {
    Structure
  },
  extends: Structure,
  data() {
    return {
      newIgnoreURL: ""
    };
  },
  mounted() {
    console.log(this.$store.getters);
  },
  methods: {
    async toggleSubjectOptimize() {
      this.$store.commit("toggleSubjectOptimize");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#subject-image {
  width: 300px;
  height: 202px;
}
</style>
